import { useEffect } from "react";
import io from "socket.io-client";
import toast, { Toaster } from "react-hot-toast";
import { registerPushToken } from "../../firebase";

// Leave unset to connect to the same origin the app is served from - in dev this goes
// through CRA's "proxy" setting (see package.json), same as the axios API calls.
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || undefined;

function NotificationContent({ payload }) {
  if (payload && typeof payload === "object" && ("to" in payload || "body" in payload)) {
    return (
      <div style={{ fontSize: 12, lineHeight: 1.4 }}>
        {payload.to && (
          <div style={{ margin: 0 }}>
            <b>To:</b> {payload.to}
          </div>
        )}
        {payload.body && (
          <div style={{ margin: 0 }}>
            <b>Message:</b> {payload.body}
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ fontSize: 12, lineHeight: 1.4, margin: 0 }}>
      {typeof payload === "string" ? payload : JSON.stringify(payload)}
    </div>
  );
}

const SocketNotifications = () => {
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      return;
    }

    // Refreshes this browser's push registration when permission was already granted (no prompt
    // here — that happens at login, inside a user gesture).
    registerPushToken({ prompt: false });

    const socket = io(SOCKET_URL, {
      path: "/socket.io",
      transports: ["websocket"],
      auth: { token },
    });

    // Every event the server pushes should be shown, regardless of its name/shape — except
    // "notification:new", which NotificationsContext already consumes to refetch the drawer.
    // Toasting it too would show a redundant, empty "{}" popup.
    socket.onAny((event, payload) => {
      if (event === "notification:new") return;
      toast(
        (t) => (
          <div style={{ display: "flex", alignItems: "flex-start", gap: 6 }}>
            <NotificationContent payload={payload} />
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: 13,
                lineHeight: 1,
                padding: 0,
                flexShrink: 0,
              }}
              aria-label="Close notification"
            >
              &times;
            </button>
          </div>
        ),
        { duration: Infinity }
      );
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <Toaster
      position="top-right"
      gutter={6}
      toastOptions={{
        style: {
          maxWidth: 240,
          padding: "6px 8px",
          borderRadius: 6,
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
        },
      }}
    />
  );
};

export default SocketNotifications;
